import useSWR from 'swr';
import Cookies from 'js-cookie';
import { fetcherWithToken } from '@/shared/api/fetcher';

export const useGameApi = () => {
  const token = Cookies.get('sessionId');
  const { data: gameData, isLoading: isGamesLoading } = useSWR(
    '/games',
    fetcherWithToken
  );
  const {
    data: recommendedData,
    isLoading: isRecommendedLoading,
    mutate: mutateRecommendedGames,
  } = useSWR(!!token ? '/recommendedGames' : null, fetcherWithToken, {
    dedupingInterval: 5000, // Не повторять запросы чаще 5 сек
    errorRetryCount: 1, // Максимум 1 повтор при ошибке
    shouldRetryOnError: false, // Отключить повтор при 500 ошибках
  });

  return {
    gameData,
    isGamesLoading,
    recommendedData,
    isRecommendedLoading,
    mutateRecommendedGames,
  };
};
